<template>
  <div class="special-offer-parent">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'SpecialOfferMainContainer',
  components: { },
  data () {
    return {}
  },
  methods: {}
}
</script>
